export const PHONE_DISPLAY = "740-747-1123";
export const PHONE_TEL = "tel:7407471123";
export const ADDRESS_LINE1 = "253 S Franklin St";
export const ADDRESS_LINE2 = "Ashley, OH 43003";
export const EMAIL = "clarkgreg52@gmail.com";
export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=253+S+Franklin+St,+Ashley,+OH+43003";
export const GOOGLE_PROFILE_URL =
  "https://www.google.com/maps/search/?api=1&query=Scrapman%27s+Metal+Recycling+LLC+253+S+Franklin+St+Ashley+OH+43003";
export const MAP_EMBED_URL =
  "https://www.google.com/maps?q=253+S+Franklin+St,+Ashley,+OH+43003&output=embed";
